import React from 'react';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import './style.scss';

export default function Tabs() {
  return (
    <TabPanel 
      focusStateEnabled={false}
    >
      <Item 
        title="Tab 1"
        icon='<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6667 2.50033H9.88C9.6 1.72699 8.86667 1.16699 8 1.16699C7.13333 1.16699 6.4 1.72699 6.12 2.50033H3.33333C2.6 2.50033 2 3.10033 2 3.83366V13.167C2 13.9003 2.6 14.5003 3.33333 14.5003H12.6667C13.4 14.5003 14 13.9003 14 13.167V3.83366C14 3.10033 13.4 2.50033 12.6667 2.50033ZM8 2.50033C8.36667 2.50033 8.66667 2.80033 8.66667 3.16699C8.66667 3.53366 8.36667 3.83366 8 3.83366C7.63333 3.83366 7.33333 3.53366 7.33333 3.16699C7.33333 2.80033 7.63333 2.50033 8 2.50033ZM6.19333 11.3603L4.46667 9.63366C4.20667 9.37366 4.20667 8.95366 4.46667 8.69366C4.72667 8.43366 5.14667 8.43366 5.40667 8.69366L6.66667 9.94699L10.5867 6.02699C10.8467 5.76699 11.2667 5.76699 11.5267 6.02699C11.7867 6.28699 11.7867 6.70699 11.5267 6.96699L7.13333 11.3603C6.88 11.6203 6.45333 11.6203 6.19333 11.3603Z" fill="#384455"/></svg>'
      >
        <div className="pa-2">Tab Content 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nisl ante, pretium a mauris bibendum, tristique condimentum neque. Fusce vitae lorem enim. Sed varius cursus nulla.</div>
      </Item>
      <Item 
        title="Tab 2"
        icon='help'
      >
        <div className="pa-2">Tab Content 2 Duis eros lectus, aliquam ac libero lacinia, posuere maximus nunc. Mauris lectus ante, convallis sed auctor a, finibus sit amet dolor. Integer sit amet erat molestie lorem rhoncus facilisis. Donec sit amet imperdiet enim, sit amet ornare nibh. Aliquam vel bibendum lorem, vitae eleifend libero</div>
      </Item>
    </TabPanel>
)}
